
import { validateAndSanitizeInput } from './sanitization';
import { commentSchema, titleSchema, abstractSchema } from './validation';

/**
 * Secure content processing for user-generated content
 */
export const processUserContent = {
  title: (input: string): string => {
    const validated = titleSchema.parse(input);
    return validateAndSanitizeInput(validated, 500, false);
  },
  
  abstract: (input: string): string => {
    const validated = abstractSchema.parse(input);
    return validateAndSanitizeInput(validated, 5000, false);
  },
  
  comment: (input: string): string => {
    const validated = commentSchema.parse(input);
    return validateAndSanitizeInput(validated, 2000, false);
  },
  
  keywords: (input: string[]): string[] => {
    return input.map(keyword => 
      validateAndSanitizeInput(keyword, 50, false)
    ).filter(Boolean);
  }
};
